import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateLocationDTO } from "./type";
import type { Location } from "@typings/entities/location";

export async function createLocation(
  location: CreateLocationDTO,
): Promise<Location> {
  const response = await apiClient.post<Location>(
    apiPaths.locations.create,
    location,
  );
  return response.data;
}
